var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEyeIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1459_24728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14C3.5 14 7.5 6 14.5 6C21.5 6 25.5 14 25.5 14C25.5 14 21.5 22 14.5 22C7.5 22 3.5 14 3.5 14Z",
    stroke: "#00B0F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17C16.1569 17 17.5 15.6569 17.5 14C17.5 12.3431 16.1569 11 14.5 11C12.8431 11 11.5 12.3431 11.5 14C11.5 15.6569 12.8431 17 14.5 17Z",
    stroke: "#00B0F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1459_24728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(2.5 2)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEyeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eyeIcon.264f2f18.svg";
export { ForwardRef as ReactComponent };